module.exports = __webpack_public_path__ + "img/3_35.76f948c2.png";